import React from 'react';
import ReactDOM from 'react-dom/client';
import { SiteNav } from '../../components/SiteNav/SiteNav';
import { SiteFooter } from '../../components/SiteFooter/SiteFooter';

type PageData = {
    csrfToken: string;
};

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const navEl = document.getElementById('legal-nav-root');
if (navEl) {
    ReactDOM.createRoot(navEl).render(React.createElement(SiteNav));
}

const footerEl = document.getElementById('legal-footer-root');
if (footerEl) {
    ReactDOM.createRoot(footerEl).render(
        React.createElement(SiteFooter, { csrfToken: pageData.csrfToken }),
    );
}

if (module.hot) { module.hot.accept(); }
